<template>
  <div class="button-box">
    <h4 class="button-box__header">{{ boxHeader }}</h4>
    <slot/>
  </div>
</template>

<script>

  export default {
    props: {
      boxHeader: {
        type: String
      }
    }
  }
</script>
